<div class="h-full w-full si-card">
  @let agentsList = (getAgents$ | async);
  @let selectedAgent = selectedAgent$ | async;
  @let summary = summary$ | async;
  <div class="flex flex-row grow-0 border-b px-4 py-2">
    <div class="flex grow items-center">
      <h3 class="pt-2 whitespace-nowrap pr-2">Growth Signals</h3>
    </div>
    @if(agentsList?.length !== 0) {
      <div class="flex items-center min-w-[5px]">
        @if (!hideAgentSelector) {
        <button matButton="outlined" type="button" class="mat-small-button mr-1 card-menu si-menu-trigger" [matMenuTriggerFor]="signalsMenu">
          <span class="si-card-menu-content">
            <span class="si-card-menu-label">{{ selectedAgent | growthSignalsAgentLabel }}</span>
            <span class="si-menu-trigger-icon" aria-hidden="true"></span>
          </span>
        </button>

        <mat-menu #signalsMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="updateSelectedAgent(null)">All Agents</button>
            @for(agent of agentsList; track agent) {
              <button mat-menu-item (click)="updateSelectedAgent(agent)">
                {{ agent.signal_type }} - {{ agent.name }}
              </button>
            }
          </ng-template>
        </mat-menu>
        }

        <mat-button-toggle-group name="type" class="mr-1 shrink-0 card-toggle-btn">
          <mat-button-toggle value="CHART" [checked]="isShowChart" (click)="isShowChart = true" class="flex items-center">
            <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
          </mat-button-toggle>
          <mat-button-toggle value="TABLE" [checked]="!isShowChart" (click)="isShowChart = false" class="flex items-center">
            <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <div [matTooltip]="(selectedAgent | growthSignalsViewAllDisabled: summary) ? (!selectedAgent ? 'View all only available when an individual Growth Signal Agent is selected.' : 'View all is disabled while this agent has not run yet.') : ''" class="shrink-0">
          <button matButton="outlined" type="button" class="mat-small-button card-btn" [disabled]="selectedAgent | growthSignalsViewAllDisabled: summary" (click)="showReport()">
            View All
          </button>
        </div>
      </div>
    }
  </div>

@if(isLoading$ | async) {
  <div class="flex justify-center items-center h-full w-full">
    <mat-spinner></mat-spinner>
  </div>
} @else {
    <div class="flex flex-col h-full w-full p-4 relative overflow-hidden">
        @if(agentsList?.length !== 0) {
          <app-growth-signals-card class="flex flex-col h-full overflow-hidden w-full"
            [isShowChart]="isShowChart"
            [selectedAgent]="selectedAgent"
            [summary]="summary"
            (setWeeklySummary)="onWeeklySummarySet($event)"
            (runAgent)="runAgent()"></app-growth-signals-card>
       } @else {
          <div class="h-full w-full p-4 content-center text-center font-bold">
            <h5>You do not currently have any Growth Signal Agents created.</h5>
            <p class="text-base text-muted">
              <a [routerLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS">Create a Growth Signal Agent</a> to be alerted when companies you care about show indicators of growth.
            </p>
          </div>
       }
    </div>
}
</div>